import { render, staticRenderFns } from "./TickerSync.vue?vue&type=template&id=41541810&scoped=true&"
import script from "./TickerSync.vue?vue&type=script&lang=js&"
export * from "./TickerSync.vue?vue&type=script&lang=js&"
import style0 from "./TickerSync.vue?vue&type=style&index=0&id=41541810&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41541810",
  null
  
)

export default component.exports